export default __webpack_public_path__ + "static/media/az.90f878f4.svg";